import { ModelBase } from 'store/model-base';

export class NowLineBadgesCollection extends ModelBase {
    public static storeName: string = 'nowLineBadgesCollection';

    public products: NowLinesProducts;

    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: NowLineBadgesCollection = super.create<NowLineBadgesCollection>(initData);

        return super.create<T>(toReturn);
    }
}
